<template>
  <div id="sectormap" @click="changeNavigate(false)">
    <mapbox @map-load="mapLoaded" @map-zoomstart="changePreviewSector(false)" @map-click="mapClicked" accessToken="pk.eyJ1IjoidGVuZHUiLCJhIjoiY2pueG1yNWhoMDB5dzNwcDYyMXE1azRxaCJ9.HDzI1WKmjXVhx6kWpcVvFA"
      :map-options="{
        style: 'mapbox://styles/tendu/cjvfj0ie20njb1fmiozwuvw4v',
        center: [mapY,mapX],
        zoom: 10,
        trackResize: true,
        refreshExpiredTiles: true,
      }"
      :geolocate-control="{
        show: false,
        position: 'top-left'
      }"
      :nav-control="{
        show: true,
        position: 'bottom-right'
      }"

      :scale-control="{
        show: false,
        position: 'top-left'
      }"
      :geocoder-control="{
        show: true,
        position: 'top-right'
      }"
      >
    </mapbox>

    <div class="sectorpreview slideInUp" style="overflow-y:scroll;" v-show="previewSector">

      <md-list>
        <md-list-item>

          <div class="md-list-text-container">
            <span class="md-subheading">{{ name }}</span>
            <span class="md-caption" style="text-overflow: ellipsis; white-space: unset;">{{ firstLine }}</span>
          </div>

        </md-list-item>
      </md-list>

      <md-divider></md-divider>
      <div id="sectorLogo">
        <div id="sectorImg" v-bind:style="{ backgroundImage: 'url(' + imageUrl + ')' }"></div>
      </div>

      <md-divider></md-divider>

      <md-bottom-bar>
        <md-bottom-bar-item md-icon="info" md-active @click="goDetails()">Halleninfo</md-bottom-bar-item>
        <md-bottom-bar-item md-icon="view_list" md-active @click="removePreview(), sendSectorLink()">Routen</md-bottom-bar-item>
        <md-bottom-bar-item md-icon="shopping_bag" md-active @click="removePreview(), goBooking()">Kurse buchen</md-bottom-bar-item>
      </md-bottom-bar>

    </div>
  </div>

</template>

<script>

import Mapbox from 'mapbox-gl-vue'
import { mapState } from 'vuex'
import { mapMutations } from 'vuex'
import { eventBus } from '../main'

export default {
  name: 'sectormap',
  components: {
    'mapbox': Mapbox
  },

  data () {
    return eventBus.$data
  },

  computed: {
    ...mapState([
      'isMapbox',
      'validUser',
      'sectorLink',
      'sectorDetails',
      'sectorStats',
      'storeList',
      'pageLoading',
      'nextLink',
      'previewSector',
      'changeSector',
      'fiterSet',
      'sectorQuery',
      'fromMap',
    ]),

    sectorId () {
      return this.$store.state.sectorDetails.id
    },
  },

  methods: {
    ...mapMutations([
      'setLink',
      'changeNavigate',
      'changePreviewSector',
      'changeSidebar',
      'changeFromMap',
      'changePageLoading',
      'changeTenduLoading',
      'setMinor',
      'setMajor',
      'forceKeyrender',
    ]),

    goDetails () {
      this.changePreviewSector (false)
      this.changeSidebar(false)
      this.changeFromMap(false)
      this.$router.push('/SectorDetails')
    },

    goBooking () {
      this.changePreviewSector (false)
      this.changeSidebar(false)
      this.changeFromMap(true)
      this.$router.push('/Booking')
    },

    removePreview () {
      this.changePreviewSector (false)
      this.changeSidebar(false)
      this.changeFromMap(true)
    },

    sendSectorLink () {
      if ((this.changeSector === this.sectorDetails.name) && (this.storeList.length > 0)) {
        // console.log('the routelist first section is already loaded')
      } else {
        this.changePageLoading(true)
        this.forceKeyrender()
        this.$store.dispatch('getList', this.sectorDetails.links.routes)
      }

      this.setMinor(this.sectorStats.gradeRange.minGradeNo)
      this.setMajor(this.sectorStats.gradeRange.maxGradeNo)

      var sectorId = this.sectorId
      this.$router.push({ name: 'routelist', params: { sectorId } })
    },

    mapLoaded (map) {
      map.loadImage('../static/pink-sector.png', (error, image) => {

        if (error) throw error
        map.addImage('cat', image)
        })

        map.addSource('sectormap', {
          type: 'geojson',
          data: process.env.BACKEND_URL + this.startLink
        })

        map.addLayer({
          'id': 'points',
          'type': 'symbol',
          'source': 'sectormap',
          'layout': {
            'icon-image': 'cat',
            'icon-size': 0.6,
            'icon-allow-overlap': true,
            'text-allow-overlap': true,
            'icon-ignore-placement': true,
            'text-field': '{noOfRoutes}',
            'text-offset': [0, -0.9],
            'text-anchor': 'top',
            'text-font': ['Arial Unicode MS Regular'],
            'text-size': 14
          },

          'paint': {
            'text-color': '#fff',
          }
        })

      map.on('mouseover', 'points', function () {
      })

      map.on('mouseenter', 'points', function () {
        map.getCanvas().style.cursor = 'pointer'
      })

      map.on('click', 'points', function (e) {
        map.flyTo({center: e.features[0].geometry.coordinates,  zoom: 16 });
      })

      map.on('mouseleave', 'points', function () {
        map.getCanvas().style.cursor = ''
      })

      this.changeTenduLoading(false)
      console.log('Map loaded')
    },

    mapClicked (map, e) {
      this.addPopUp(map, e)
      map.resize()
    },

    addPopUp (map, e) {
      this.changePreviewSector(false)
      const features = map.queryRenderedFeatures(e.point, {
        layers: ['points']
      })

      if (!features.length) {
        return
      }
      this.name = features[0].properties.name
      this.firstLine = features[0].properties.firstLine
      this.imageUrl = features[0].properties.imageUrl

      this.$store.commit('setLink', features[0].properties.sectorLink)
      this.$store.dispatch('getSector', this.sectorLink)
      .then(response => {
        this.changePreviewSector(true)
      })
    },
  }
}

</script>

<style>

  #map {
    position: absolute;
    top: 0px !important;
    bottom: 0 !important;
    width:100% !important;
    -ms-touch-action: none !important;
    touch-action: none !important;
  }

  #points {
    font-size:84px;
    height:120px;
    width:120px;
    background-color:red;
  }

  .marker {
    background-color:red;
    background-size: cover;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    cursor: pointer;
  }

  #sectormap .mapboxgl-ctrl-top-right {
  }

  #sectormap .mapboxgl-ctrl-bottom-left {
    display:none;
  }

  #sectormap .mapboxgl-ctrl-geocoder {
  }

  #sectormap .mapboxgl-ctrl-top-right .mapboxgl-ctrl {
    margin-top: 74px
  }

  #sectormap .mapboxgl-ctrl-geocoder, .mapboxgl-ctrl-geocoder ul {
  }

  .sectorpreview {
    position:fixed;
    z-index:50;
    font-family:'Roboto';
    /* padding-bottom:10px; */
    /* height:270px !important; */
    bottom:0px !important;
    background-color: #ffffff;
    width:100%;
    overflow:hidden;
  }

  .slideInUp {
    -webkit-animation-name: slideInUp;
    animation-name: slideInUp;
    -webkit-animation-duration: 0.5s;
    animation-duration: 0.5s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    }
    @-webkit-keyframes slideInUp {
    0% {
    -webkit-transform: translateY(100%);
    transform: translateY(100%);
    visibility: visible;
    }
    100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    }
    }
    @keyframes slideInUp {
    0% {
    -webkit-transform: translateY(100%);
    transform: translateY(100%);
    visibility: visible;
    }
    100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    }
    }

  .sectorpreview p {
    overflow: hidden;
    max-height: 15px;
    margin-top:4px;
  }

  #sectorLogo {
    max-height:140px;
    max-width:380px;
    margin:auto;
  }

  #sectorImg {
    height:120px;
    background-size:contain;
    background-position:center;
    background-repeat:no-repeat;
  }

  #sectormap .mapboxgl-popup-tip {
    display:none !important;
  }

  #previewTenduTab .md-tab-header-container {
    text-transform:none;
  }

  #previewTenduTab.md-theme-default.md-tabs.md-transparent>.md-tabs-navigation {
    background-color: #ffffff !important;
    border-bottom:none !important;
    border-top:1px solid #ccc;
    position:fixed;
    width:100%;
    top:208px;
  }

  #sectormap .md-bottom-bar {
    -webkit-box-shadow: unset;
    box-shadow:unset;
    height:66px;
  }

  #sectormap .md-bottom-bar-item{
    padding: 8px 10px 10px;
  }

</style>
